import { AccordionSummary } from './AccordionSummary';
import { AccordionDetails } from './AccordionDetails';
import { Accordion as AccordionComponent, type AccordionProps } from './Accordion';
import { AccordionStateProvider, useAccordionState, AccordionStateConsumer } from './AccordionState';

export { AccordionSummary, AccordionDetails, type AccordionProps, useAccordionState };

export const Accordion = Object.assign(AccordionComponent, {
  Summary: AccordionSummary,
  Details: AccordionDetails,
  StateProvider: AccordionStateProvider,
  StateConsumer: AccordionStateConsumer
});
